export default "__VITE_ASSET__19668530__$_?component__"